module.exports = __webpack_public_path__ + "img/Bernardo_Castro_Vitorino.034b142e.jpg";